import { gql } from "@apollo/client";

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile(
    $userId: Int! 
    $email: String
    $username: String
    $planId: Int
    $url: String
    $desc: String
    $hours24: Boolean
    $timeZoneId: Int
    $calendar: String
    $defaultBusinessId : Int
    $defaultPageId: Int
  ) {
    updateProfile(
      userId: $userId  
      email: $email
      username: $username
      planId: $planId
      url: $url
      desc: $desc
      hours24: $hours24
      timeZoneId: $timeZoneId
      calendar: $calendar
      defaultBusinessId: $defaultBusinessId
      defaultPageId: $defaultPageId
    ) {
     token
    }
  }
`;
export const ADD_BOOKINGS = gql`
  mutation AddBooking($input: AddBookingInput) {
    addBooking(input: $input) {
      id
      bookingTypeId
      timezone
      bookingId
      time
      finalPrice
      discount
    }
  }
`; 
export const GET_RATING_DETAILS = gql`
  mutation getRatingDetails($ratingId: Int!) {
    getRatingDetails(ratingId: $ratingId) {
      id
      bookingId
      bookingTypeId
      name
      review
      desc
      rating
    }
  }
`;
export const getBookingAnswersBased = gql`
  mutation getBookingAnswersBased($bookingId: Int!, $questionName: String!) {
    getBookingAnswersBased(bookingId: $bookingId, questionName: $questionName) {
      id
      answer
    }
  }
`;
export const ADD_RATING = gql`
  mutation AddRating(
    $bookingTypeId: Int!
    $rating: Int!
    $bookingId: String!
    $desc: String!
    $review: String!
  ) {
    addRating(
      bookingTypeId: $bookingTypeId
      rating: $rating
      bookingId: $bookingId
      desc: $desc
      review: $review
    ) {
      bookingTypeId
      rating
      bookingId
      desc
      review
    }
  }
`;
export const GET_BOOKING_TYPE = gql`
  mutation getBookingType($id: Int!) {
    getBookingType(id: $id) {
      id
      color
      title
      businessId
    }
  }
`;
 
export const ADD_BOOKING_EXCEPTION = gql`
  mutation ($input: BookingExceptionInput!) {
    addBookingException(input: $input) {
      id
      bookingId
      exceptionDate
      reason
      createdAt
      updatedAt
    }
  }
`;


export const REMOVE_BOOKINGS = gql`
  mutation ($bookingId: Int!) {
    removeBooking(bookingId: $bookingId) {
      id
    }
  }
`;
export const SIGNUP_USER_GOOGLE = gql`
  mutation SignUpGoogle($email: String!, $username: String!, $timeZoneId: Int) {
    signUpGoogle(email: $email, username: $username, timeZoneId:$timeZoneId) {
      token
    }
  }
`;
export const SIGNUP_USER = gql`
  mutation SignUp(
    $email: String!
    $password: String
    $username: String 
     $timeZoneId: Int
  ) {
    signUp(email: $email, password: $password, username: $username, timeZoneId:$timeZoneId) {
      token
    }
  }
`;

export const ADD_SUBSCRIPTION = gql`
  mutation addPlanSubscription(
    $businessId: Int
    $planId: Int!
    $type: String!
    $token: String!
  ) {
    addPlanSubscription(businessId: $businessId, planId: $planId, type: $type, token: $token)
  }
`;

export const LOGIN_WITH_GOOGLE = gql`
  mutation loginWithGoogle($email: String!) {
    loginWithGoogle(email: $email) {
      token
    }
  }
`;

export const LOGIN_USER = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $email: String!
    $password: String!
    $resetToken: String!
  ) {
    resetPassword(email: $email, password: $password, resetToken: $resetToken) {
      email
    }
  }
`;

export const REQUEST_RESET = gql`
  mutation RequestReset($email: String!) {
    requestReset(email: $email) {
      email
      resetToken
    }
  }
`;
export const DELETE_INVITEE_QUESTION = gql`
  mutation deleteInviteeQuestion($id: ID!) {
    deleteInviteeQuestion(id: $id)
  }
`;
export const ADD_INVITEE_QUESTION = gql`
  mutation addInviteeQuestion(
    $bookingTypeId: Int!
    $questionId: Int
    $type: String!
    $title: String!
    $required: Boolean!
    $options: [String]
  ) {
    addInviteeQuestion(
      bookingTypeId: $bookingTypeId
      type: $type
      title: $title
      required: $required
      options: $options
      questionId: $questionId
    ) {
      id
      bookingTypeId
      type
      title
      required
    }
  }


`;


// Define the GraphQL mutation
export const VERIFY_STAFF_MUTATION = gql`
  mutation VerifyStaffApply($id: String!) {
    verifyStaffApply(id: $id) {
      user {
        email
        password
         timeZone {
        id,
        timezone
        }
      } 
    }
  }
`;

export const CREATE_TRANSACTION = gql`
  mutation createTransaction($input: CreateTransactionInput!) {
    createTransaction(input: $input) {
      id
    }
  }
`;

export const UNSUBSCRIBE = gql`
 mutation unsubscribe($userId: Int!, $subscriptionID: String!) {
  unsubscribe(userId: $userId, subscriptionID: $subscriptionID){
    message
    success
    token
  }
}
`;

export const UPDATE_PAYPAL_SUBSCRIPTION = gql`
mutation UpdatePaypalSubscription($subscriptionID: String!, $quantity: Int) {
  updatePaypalSubscription(subscriptionID: $subscriptionID, quantity: $quantity) {
    success
    data
    message
  }
}
`;


export const EXCHANGE_GOOGLE_CALENDAR_CODE = gql`
    mutation ExchangeGoogleCalendarCode($code: String!, $staffId: Int) {
        exchangeGoogleCalendarCode(code: $code, staffId: $staffId) {
            success
            events {
            id}
        }
    }
`;

export const DELETE_GOOGLE_CALENDAR_INTEGRATION = gql`
 mutation DeleteGoogleCalendarIntegration($staffId: Int!) {
  deleteGoogleCalendarIntegration(staffId: $staffId) {
  success
  message  
  }
}
`;

export const UPDATE_DEFAULT_BUSINESS = gql`
  mutation UpdateDefaultBusiness($userId: Int!, $defaultBusinessId: Int!) {
    updateDefaultBusiness(userId: $userId, defaultBusinessId: $defaultBusinessId) {
      id
    }
  }
`;

export const UPDATE_STAFF_GOOGLE_EVENTS = gql`
  mutation UpdateStaffGoogleEvents($staffId: Int!, $showGoogleEvents: Boolean!) {
    updateStaffGoogleEvents(staffId: $staffId, showGoogleEvents: $showGoogleEvents) {
      success
      showGoogleEvents
    }
  }
`;